import * as z from "../../../vendor/zod/src/index";
export default z.object({
    id: z.string(),
    png: z.string(),
});
